import { AfterViewInit, Component, ElementRef, Input, OnInit } from "@angular/core";
import { ResourceFilterBarComponentController } from "@directives/_resourceFilters/newResourceFilterBar.component";
import { VeriSearchBoxComponent } from "@directives/_veri/veriSearchBox/veriSearchBox.directive";
import { IVeriTableBindings } from "@directives/_veri/veriTable/veriTable.component";
import { HTMLService } from "@services/htmlService.service";
import "./page-actions.component.scss";

@Component({
    selector: "page-actions",
    template: require("./page-actions.component.html")
})
export class PageActionsComponent implements OnInit, AfterViewInit {

    @Input() veriTable: IVeriTableBindings;
    @Input() showRouteTitle: boolean;
    @Input() noexport: boolean;

    // ---

    searchBox: VeriSearchBoxComponent;

    constructor(
        private readonly elementRef: ElementRef,
        private readonly htmlService: HTMLService) {
    }

    ngOnInit(): void {
    }

    ngAfterViewInit() {
        this.findAndRegisterTable();
        this.findAndRegisterFilterBar();

        this.removeIfEmpty(".search-row");
    }

    registerSearchBox(searchBox: VeriSearchBoxComponent) {
        if (this.searchBox) {
            return;
        }

        this.searchBox = searchBox;

        this.searchBox.onChange.subscribe(event => {
            if (!this.veriTable) {
                return;
            }

            this.veriTable.searchBox = this.searchBox;
            this.veriTable.searchString = event;
            this.veriTable.searchRows(true);
        });
    }

    // ---

    private findAndRegisterTable() {
        var nearest = this.htmlService.findNearest(this.elementRef.nativeElement, "veri-table");
        this.veriTable = this.htmlService.getAngularJSComponentFromElement<IVeriTableBindings>(nearest);

        if (this.veriTable) {

            var existingCallback = this.veriTable.onRowsUpdated;
            this.veriTable.onRowsUpdated = (args) => {
                if (this.searchBox) {
                    this.searchBox.placeholderCount = args.rows.length
                    this.searchBox.updatePlaceholderTranslation();
                }

                if (existingCallback) {
                    existingCallback(args);
                }
            };
        }
    }

    private findAndRegisterFilterBar() {
        if (!this.veriTable) {
            return;
        }

        var nearest = this.htmlService.findNearest(this.elementRef.nativeElement, "new-resource-filter-bar");
        var filterBar = this.htmlService.getAngularJSComponentFromElement<ResourceFilterBarComponentController>(nearest);

        if (filterBar) {

            filterBar.veriTable = this.veriTable;
        }
    }

    private removeIfEmpty(selector: string) {
        const nearest = this.htmlService.findNearest(this.elementRef.nativeElement, selector, null, { stopTagNames: ["default-layout"] });
        if (!nearest) {
            return;
        }

        let isEmpty = true;

        nearest.childNodes.forEach(child => {
            if (!isEmpty) {
                return;
            }

            if ((child.nodeName != "#comment" && child.textContent.trim() != '') || child.childNodes.length > 0) {
                isEmpty = false;
            }
        });

        if (isEmpty) {
            nearest.remove();
        }
    }
}
